import { useAtom } from "jotai";
import { useEffect } from "react";
import overrideService from "services/OverrideService";
import ApiService from "services/ApiService";
import { expandedJobDetailsAtomObject, isLoadingAtomBool } from "../state";
import { useNavigate } from "react-router-dom";

const useJobDetails = () => {
  const [, setIsLoading] = useAtom(isLoadingAtomBool);
  const [expandedJobDetails, setExpandedJobDetails] = useAtom(expandedJobDetailsAtomObject);
  const navigate = useNavigate();

  
  const handleExpandJobDetails = async (e, job) => {
     setIsLoading(true);
    let override = await overrideService.getOverride();
    let inlineDetails = await overrideService.getInlineDetails();
    if (inlineDetails || !job.url || job.url === '#') {
      if (e) {
        e.preventDefault();
      }

      ApiService.details(job.id, job.slug).then((res) => {
        let html = "Cannot show job details.";
        if (res && res.data) {
          html = res.data;
          let replaceFragmentList = ['back-to-link', 'aside-register-cta'];
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          replaceFragmentList.forEach(className => {
            doc.querySelectorAll(`.${className}`).forEach(el => el.remove());
          });
          html = doc.body.innerHTML;

          let overrideString = override ? `override=${override}` : '';
          html = html.replaceAll('action="/api/form/jobapplication/jobapplication/"', `action="${process.env.REACT_APP_PUBLIC_GATEWAY_URL}/job-details/jobapplication/jobapplication?${overrideString}"`);
        }
        

        setExpandedJobDetails({
          ...expandedJobDetails,
          id: job.id,
          slug: job.slug,
          html: '<div>' + html + '</div>'
        });
        setIsLoading(false);

        // const customEvent = new CustomEvent('message', { detail: job.id > 0 ? job.id.toString() : job.slug });
        // window.dispatchEvent(customEvent)

      })
        .catch((ex) => {
          setIsLoading(false);
          console.error("Failed to load job details", ex);

          throw ex;
        })
        .finally(() => {
        setIsLoading(false);
      });
    }

  }
  return handleExpandJobDetails;

}


export default useJobDetails;
